var React = require('react');

function PhishingLight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.1 4.4h-20c-1.65 0-3 1.35-3 3v14c0 1.65 1.35 3 3 3h20c1.65 0 3-1.35 3-3v-14c0-1.65-1.35-3-3-3zm-21 3c0-.55.45-1 1-1h20c.55 0 1 .45 1 1v.45l-9.95 6.21c-.64.4-1.48.4-2.12 0L6.1 7.85V7.4zm21 15h-20c-.55 0-1-.45-1-1V10.2l8.87 5.55c.64.4 1.38.6 2.12.6.74 0 1.48-.2 2.12-.6l8.89-5.55v11.2c0 .55-.45 1-1 1zm16.79 9.46c0-1.9-1.33-3.48-3.11-3.88V1c0-.55-.45-1-1-1s-1 .45-1 1v27.06c-1.65.49-2.86 2-2.86 3.81s1.21 3.32 2.86 3.81v8.14c0 .53-.21 1.03-.58 1.41-.74.74-2.07.74-2.81 0-.38-.38-.58-.87-.58-1.41v-1.99c0-.55-.45-1-1-1s-1 .45-1 1v1.99a3.998 3.998 0 003.99 3.99 3.998 3.998 0 003.99-3.99v-8.07c1.78-.4 3.11-1.99 3.11-3.88l-.01-.01zm-3.99 1.99c-1.1 0-1.99-.89-1.99-1.99s.89-1.99 1.99-1.99 1.99.89 1.99 1.99-.89 1.99-1.99 1.99z"}));
}

PhishingLight.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = PhishingLight;

PhishingLight.default = PhishingLight;
